var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rating-icon",class:{'has-count': _vm.showCount}},[_c('img',{attrs:{"src":_vm.rating
        ? require('@/assets/images/icons/good.svg')
        : require('@/assets/images/icons/bad.svg')}}),(_vm.showCount)?_c('strong',{staticClass:"rating-count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }